export enum MessagesEvent {
  SendMessage = "SEND_MESSAGE",
  EditMessage = "EDIT_MESSAGE",
  DeleteMessage = "DELETE_MESSAGE",
  RestoreMessage = "RESTORE_MESSAGE",
  ReceiveMessage = "NEW_MESSAGE",

  GetAllConversations = "SHOW_CONVERSATION_SUMMARIES",

  CreateConversation = "CREATE_CONVERSATION",
  GetConversation = "SHOW_CONVERSATION",
  ReceiveConversation = "CONVERSATION",
  ReceiveConversationUpdate = "CONVERSATION_UPDATE",
  ReceiveMessageUpdate = "MESSAGE_UPDATE",
  MarkConversationAsRead = "MARK_AS_READ",
}
